import Client from './client';

export default class RestrictionItems extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/items`, options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/items`, {
      ...options,
       method: 'POST',
    });
  }

  getById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/items/${id}`, options);
  }

  putById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/items/${id}`, {
      ...options,
       method: 'PUT',
    });
  }

}
